import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {Router} from '@angular/router';
import {MenuService} from '../../../services/menu.service';
import {ModuleService} from '../../../services/module.service';
import {PermissionService} from '../../../services/permission.service';

@Component({
  selector: 'app-single-edit',
  templateUrl: './single-edit.component.html',
  styleUrls: ['./single-edit.component.scss']
})
export class SingleEditComponent implements OnInit{

  menuForm: FormGroup;
  modules: any[] = [];
  permissions: any[] = [];

  public types: any[] = [
    {id: 1, name: 'link', title: 'single'}
  ];
  moduleSelected: number | undefined;
  typeSelected: string | undefined;
  permissionsSelected: any[] = [];

  saving = false;

  waitingModule = false;
  waitingChildren = false;
  loading = 'Loading...';

  public data: any;

  isSubmitted = false;

  update = this.translate.instant('Update');
  create = this.translate.instant('Save');

  @ViewChild(DatatableComponent) table: DatatableComponent;
  changeDetectorRefs: ChangeDetectorRef[] = [];

  constructor(private fb: FormBuilder,
              private menuService: MenuService,
              private moduleService: ModuleService,
              private permissionService: PermissionService,
              private translate: TranslateService,
              private toastr: ToastrService,
              public activeModal: NgbActiveModal,
              public route: Router
  ) {
    this.menuForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      path: [''],
      icon: [''],
      type: ['', [Validators.required]],
      module: ['', [Validators.required]],
      position: [''],
      permissions: [''],
      title: this.types[0]["title"],
      isEnable: '',
    });

  }

  ngOnInit(): void {
    this.menuForm.get('isEnable')?.setValue('1');
    this.waitingModule = true;
    this.waitingChildren = true;
    this.menuForm.patchValue(this.data);
    console.log(this.data);

    this.moduleSelected = this.data.module['@id'];

    this.permissionsSelected = this.data.permissions.map((c: any) => c['@id']);
    this.menuForm.get('isEnable')?.setValue(this.data.isEnable ? '1' : '0');
    console.log(this.permissionsSelected);

    this.findAllModule();

    this.findAllPermissions();

    this.typeSelected = 'link'

  }

  get fc(): any {
    return this.menuForm.controls;
  }

  onFormSubmit(): void{
    this.isSubmitted = true;
    if (this.menuForm.valid){
      this.saving = true;
      if (this.data){
        this.menuForm.get('isEnable')?.setValue(this.menuForm.get('isEnable')?.value === '1');
        this.menuService.putSingle(this.data.id, this.menuForm.value).subscribe({
          next: (val: any) => {
            this.toastr.success('Menu edit with success !', 'Success');
            this.activeModal.close();
          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) =>
          {
            console.log(err);
            // const errors: any[] = err.error.violations;
            const errors: any[] = err.violations;

            if (errors){
              errors.forEach((v) =>
              {
                if (v.propertyPath === 'module'){
                  this.menuForm.get('module')?.setErrors({serverError: v.message});
                }
                console.log(v.message);
                if (v.propertyPath === 'name'){
                  this.menuForm.get('name')?.setErrors({serverError: v.message});
                }
                if (v.propertyPath === 'position'){
                  this.menuForm.get('position')?.setErrors({serverError: v.message});
                }

                this.saving = false;
              });
            }
            else {
              this.toastr.error(err['hydra:title'], 'Error');
              this.saving = false;
            }

          }
        });
      }


    }
  }


  findAllModule() {
    this.moduleService.getEnableCollection().subscribe({
      next: (data: any) => {
        console.log(data['hydra:member']);
        this.modules = data['hydra:member'];
        if (this.modules){
          this.modules = this.modules.map((v) => {
            v.id = v['@id'];
            return v;
          });
          this.waitingModule = false;
        }
      },
      // complete: () => this.findAllPermissions(),
      // error: (error: HttpErrorResponse) => {
      //   this.findAllPermissions()
      //   console.log(error);
      // }
    });
  }

  findAllPermissions(): any{
    console.log(this.data.permissions);
    this.permissionService.getEnableCollection().subscribe((data: any) => {
          this.permissions = data['hydra:member'];
          console.log(this.permissions);
          this.permissions = this.permissions.map((v) => {
            v.id = v['@id'];
            v.name = v['name'];
            console.log(v['@id']);

            return v;
          });


        },
        error => console.log(error)
    );
  }


}
